var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FCPWrapper',[_c('BaseAdvancedTable',{attrs:{"actions":[],"fields":_vm.fields,"items":_vm.items,"busy":_vm.isBusy,"sort-desc":false,"sort-by":"age","fitTableBodyToWindow":_vm.fitTableBodyToWindow},scopedSlots:_vm._u([{key:"cell(UMR)",fn:function(ref){
var ref_data = ref.data;
var value = ref_data.value;
var item = ref_data.item;
return [('Pending' === item.status)?_c('b-icon',{staticClass:"mr-2",attrs:{"icon":"clock-history"}}):_vm._e(),_vm._v(_vm._s(value))]}},{key:"cell(uploaded_on)",fn:function(ref){
var value = ref.data.value;
return [_vm._v(_vm._s(_vm.moment(value).format("MM/DD/YYYY hh:mm A")))]}},{key:"cell(link)",fn:function(ref){
var item = ref.data.item;
return [(item.uploaded_file_id)?_c('router-link',{attrs:{"to":{
          name: 'FCPLogPreview',
          params: {
            uniqueId: item.uploaded_file_id,
            fileName: item.filename,
          },
        }}},[_vm._v("View File")]):[_vm._v("N/A")]]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }